<template>
    <div class="MyDownloads">
        <el-card class="box-card" v-loading="is_download_history_in_progress">
            <el-collapse v-model="my_downloads_collapse" accordion>
                <el-collapse-item name="1">
                    <template slot="title">
                        <div class="flex">
                            <img src="../assets/images/myAccount/Transaction history - Icon.svg" style="width: 16px;">
                            <div class="label-md-bold-black left-margin-10">Download History</div>
                        </div>
                    </template>

                    <div class="download-container">
                        <div class="download-details-section">
                            <el-row>
                                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                    <div class="flex top-margin-20 input-section">
                                        <el-input
                                            class="search-input"
                                            placeholder="Search"
                                            size="mini"
                                            suffix-icon="el-icon-search"
                                            v-model="search_download_history">
                                        </el-input>

                                        <!-- <el-select v-model="downloads_category" size="mini" class="select-input" placeholder="Select">
                                            <el-option label="All categories" value="all_categories"></el-option>
                                        </el-select> -->
                                    </div>
                                    <el-table
                                        :data="download_history_list.length ? download_history_list.filter(data => data.csv_file_name.toLowerCase().includes(search_download_history.toLowerCase())) : []"
                                        max-height="450"
                                        style="width: 100%"
                                    >
                                        <el-table-column prop="csv_file_name" width="220" fixed></el-table-column>

                                        <el-table-column width="200" align="center">
                                            <template slot-scope="scope">
                                                <span class="sub-text">{{ download_history_list[scope.$index].created_date }}</span>
                                            </template>
                                        </el-table-column>

                                        <el-table-column width="240" align="center">
                                            <template slot-scope="scope">
                                                <span class="sub-text" style="font-size: 12px;">Status : </span><span style="font-size: 12px;" :style="[ download_history_list[scope.$index].status =='completed' ? { color: '#079e3e' } : download_history_list[scope.$index].status == 'in_process' ? { color: '#e2ba00' } : '#d60918' ]">
                                                    {{ download_history_list[scope.$index].status =='completed' ? 'Success' : download_history_list[scope.$index].status == 'in_process' ? 'Pending' : 'Failed' }}
                                                </span>
                                            </template>
                                        </el-table-column>

                                        <el-table-column align="center">
                                            <template slot-scope="scope">
                                                <span v-if="download_history_list[scope.$index].txn_amount">
                                                    ₹ {{ download_history_list[scope.$index].txn_amount }}
                                                </span>
                                                <span v-else>-</span>
                                            </template>
                                        </el-table-column>

                                        <el-table-column align="right">
                                            <template slot-scope="scope">
                                                <el-button
                                                type="primary"
                                                size="mini"
                                                round
                                                class="btn"
                                                v-if="download_history_list[scope.$index].status =='completed'"
                                                v-on:click.native="downloadCsv(download_history_list[scope.$index].file)"
                                                >DOWNLOAD CSV</el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                </el-collapse-item>
            </el-collapse>
        </el-card>
    </div>
</template>
<script>
import { serverAddr, serverHostName } from "../networkConfig";
import { filterCallBack } from "../mixins/filter";
import NoDataFound from "@/components/NoDataFound.vue";
import { EventBus } from "../eventBus";
import moment from 'moment';

    export default {
        name: 'MyDownloads',
        mixins: [filterCallBack],
        components: {
            NoDataFound
        },
        data(){
            return {
                nav_title: 'My Account',
                my_downloads_collapse: '1',
                is_download_history_in_progress: false,
                search_download_history: '',
                downloads_category: 'all_categories',
                download_history_list: [],
                moment: moment,
                server_addr: serverHostName
            }
        },
        computed: {
            //returns stored user profile from local storage
            userProfile() {
                return JSON.parse(localStorage.getItem("profile"));
            },
        },

        mounted() {
            this.getMyDownloadedStuff();
        },

        methods: {
            downloadCsv(url){
                if(url){
                    var element = document.createElement('a');
                    element.setAttribute('href', this.server_addr+'/Media/'+url);
                    element.setAttribute('download', '');

                    element.style.display = 'none';
                    document.body.appendChild(element);
                    element.click();
                    document.body.removeChild(element);
                }
            },
            getMyDownloadedStuff(){
                this.is_download_history_in_progress = true;     //enabled loader
                serverAddr
                    .get("/stockants_pro/my_downloads/")
                    .then(response => {
                        if (response.data.status) {
                            this.download_history_list = response.data.data;
                        }
                        this.is_download_history_in_progress = false;     //disabled loader

                        this.no_download_reco_category_selected_error = false;       //disabled error msg
                    })
                    .catch(
                        function(error) {
                            console.log(error);
                            this.is_download_history_in_progress = false;     //disabled loader
                        }.bind(this)
                    );
            }
        },

        beforeDestroy(){
            EventBus.$off();
        },
    }
</script>
<style lang="scss" scoped>
@import "../css/variable.scss";
@import "../css/common.scss";

.MyDownloads .search-input{
    margin-right: 10px;
}
@media screen and (max-width: 575px) {
    .MyDownloads .input-section{
        flex-wrap: wrap;
        justify-content: center;
        .search-input, .select-input{
            margin-bottom: 10px;
        }
    }
}

@media screen and (max-width: 1283px) {
  .MyDownloads {
    padding: 50px 0 0 0;
  }
  .MyDownloads .sideBarSection {
    display: none;
  }
}
</style>
<style lang="scss">
@import "../css/variable.scss";
@import "../css/common.scss";

.MyDownloads .box-card {
    border-radius: 10px !important;
    border: none;
    box-shadow: none;
}

.MyDownloads .input-section{
    .search-input{
       width: 200px;
       .el-input__inner{
           border-radius: 50px!important;
       }
    }
    .select-input{
        width: 150px;
    }
}
.MyDownloads .el-table__row .cell{
    color: #000;
    font-size: 0.8rem;
    font-weight: 500;

    .sub-text{
        font-size: 0.7rem;
        color: #999;
    }
}
.MyDownloads .el-table__fixed{
    z-index: 1;
}
.MyDownloads .btn{
    color: $secondary-theme-color;
    border-color: $secondary-theme-color;
    background-color: #fff;
    font-size: 11px;
    padding: 3px 12px;
    line-height: 1.5;
}
.MyDownloads .btn:hover{
    color: #fff;
    border-color: $secondary-theme-color;
    background-color: $secondary-theme-color;
}
</style>
